import { render, staticRenderFns } from "./OrganismTitleAndDescription.vue?vue&type=template&id=1c04df73&scoped=true&"
import script from "./OrganismTitleAndDescription.vue?vue&type=script&lang=js&"
export * from "./OrganismTitleAndDescription.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTitleAndDescription.vue?vue&type=style&index=0&id=1c04df73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c04df73",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitleAndDescription: require('/app/components/atoms/common/AtomTitleAndDescription.vue').default,MoleculesCommonMoleculeTitleAndDescription: require('/app/components/molecules/common/MoleculeTitleAndDescription.vue').default})
